import assortmentNavigationTrigger from '@coolblue-development/ga4-events/triggers/AssortmentEntranceNavigation/assortmentNavigationTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
export const useNavigationCategoryDropdownTrackingEvents = () => {
    const { trackEvent } = useAnalytics();
    const trackOpenEvent = () => {
        trackEvent(assortmentNavigationTrigger({
            sub_feature: 'header',
            content: 'open_assortment',
        }));
    };
    const trackCloseEvent = () => {
        trackEvent(assortmentNavigationTrigger({
            sub_feature: 'header',
            content: 'close_assortment',
        }));
    };
    return { trackCloseEvent, trackOpenEvent };
};
//# sourceMappingURL=CategoryNavigationDropdownTrackingEvents.js.map